var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0603 20.2598H6.12731C5.85131 20.2598 5.62731 20.4838 5.62731 20.7598V21.7598C5.62731 22.0363 5.85131 22.2598 6.12731 22.2598H19.0603C19.3363 22.2598 19.5603 22.0363 19.5603 21.7598V20.7598C19.5603 20.4838 19.3363 20.2598 19.0603 20.2598ZM5.93981 12.0273C5.35381 11.4418 5.35331 10.4923 5.93881 9.90577L6.29231 9.55227L11.5938 14.8478V2.25977H13.5938V14.8453L18.8863 9.55277L19.2398 9.90627C19.8258 10.4918 19.8258 11.4418 19.2398 12.0278L12.5943 18.6738L5.93981 12.0273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.c20814618a91453d04f3c86f74782ef6.svg";
export { ForwardRef as ReactComponent };